<template>
  <ion-card mode="ios" style="margin: 15px 0; background: #fff">
    <ion-card-header>
      <slide-y-up-transition :duration="700">
        <h6 v-show="show" class="text-up m-0">Filtrowanie wyników</h6>
      </slide-y-up-transition>
    </ion-card-header>
    <ion-card-content style="padding-top: 0">
      <slide-x-left-transition :duration="500" :delay="600">
        <div v-if="show" class="box-info warning">
          Weryfikuj swoją sprzedaż na bieżąco! Raz w tygodniu będziemy aktualizować Twoją bieżącą sprzedaż z
          obecnego miesiąca. Naliczenie bonów i rozliczenie reklamacji nastąpi około 15 dnia nowego miesiąca.
        </div>
      </slide-x-left-transition>
      <slide-x-left-transition :duration="500" :delay="800">
        <form-loyalty-filter-results></form-loyalty-filter-results>
      </slide-x-left-transition>
    </ion-card-content>
  </ion-card>
</template>

<script>
  import FormLoyaltyFilterResults from '@/forms/loyalty/FormLoyaltyFilterResults';

  export default {
    name: 'CardLoyaltyFilterResults',
    components: { FormLoyaltyFilterResults },
    data() {
      return {
        show: false
      }
    },
    mounted() {
      this.show = true
    }
  }
</script>